import { Routes } from "@angular/router";
import { contactDealerComponentResolver, dealerLocatorComponentResolver, dealerLocatorGoogleMapsResolver } from "./_lib/resolvers/dealer-locator-component.resolver";
import { blogComponentResolver, newsComponentResolver } from "./_lib/resolvers/news-component.resolver";
import { AuthGuard } from "src/_lib/service/auth.guard";
import { SeoResolver } from "./_lib/resolvers/seo.resolver";
import { placeholderComponentResolver } from "./_lib/resolvers/palceholder-component.resolver";

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./app/templates/home/home.component').then(m => m.HomeComponent),
        resolve: { seo: SeoResolver },
        data: { pageCode: 'home' }
      },
      {
        path: 'p',
        children: [
          {
            path: '**',
            loadComponent: () =>
              import('./app/templates/product-category-brand-redirect/product-category-brand-redirect.component').then(m => m.ProductCategoryBrandRedirectComponent),
          }
        ]
      },
      {
        path: 'product/:productname',
        loadComponent: () =>
          import('./app/templates/product-category-brand-redirect/product-category-brand-redirect.component').then(m => m.ProductCategoryBrandRedirectComponent),
      },
      {
        path: 'product-brand',
        children: [
          {
            path: '**',
            loadComponent: () =>
              import('./app/templates/product-category-brand-redirect/product-category-brand-redirect.component').then(m => m.ProductCategoryBrandRedirectComponent),
          }
        ]
      },
      {
        path: 'product-category',
        children: [
          {
            path: '**',
            loadComponent: () =>
              import('./app/templates/product-category-brand-redirect/product-category-brand-redirect.component').then(m => m.ProductCategoryBrandRedirectComponent),
          }
        ]
      },
      {
        path: 'wp-content/uploads',
        children: [
          {
            path: '**',
            loadComponent: () =>
              import('./app/templates/img-redirect/img-redirect.component').then(m => m.ImgRedirectComponent),
          }
        ]
      },
      {
        path: 'blog-details',
        loadComponent: () =>
          import('./app/templates/latest-news/component/blog-details/blog-details.component').then(m => m.BlogDetailsComponent),
        resolve: {seo:SeoResolver},
      },
      {
        path: 'become-dealer',
        loadComponent: () =>
          import('./app/templates/become-dealer/become-dealer.component').then(m => m.BecomeDealerComponent),
        resolve: { seo: SeoResolver },
      },
      {
        path: 'customer-login',
        loadComponent: () =>
          import('./app/templates/customer-login/customer-login.component').then(m => m.CustomerLoginComponent),
        resolve: { seo: SeoResolver },
        data: { pageCode: 'customer_login' }
      },
      {
        path: 'promos',
        loadComponent: () =>
          import('./app/templates/promos/promos.component').then(m => m.PromosComponent),
        resolve: { seo: SeoResolver },
        data: { pageCode: 'promos' }
      },
      {
        path: 'promotion-details/:promoid',
        loadComponent: () =>
          import('./app/templates/promos/component/promotion-details/promotion-details.component').then(m => m.PromotionDetailsComponent),
        resolve: { seo: SeoResolver },
        data: { pageCode: 'promo_details' }
      },
      {
        path: 'customer-gallery',
        loadComponent: () =>
          import('./app/templates/customer-gallery/customer-gallery.component').then(m => m.CustomerGalleryComponent),
        resolve: { seo: SeoResolver },
        data: { pageCode: 'customer_gallery' }
      },
      {
        path: 'customer-gallery/page/:pageCode',
        loadComponent: () =>
          import('./app/templates/customer-gallery/customer-gallery.component').then(m => m.CustomerGalleryComponent),
        resolve: { seo: SeoResolver },
        data: { pageCode: 'customer_gallery' }
      },
      {
        path: 'submit-your-ride',
        loadComponent: () =>
          import('./app/templates/customer-gallery/component/submit-your-ride/submit-your-ride.component').then(m => m.SubmitYourRideComponent),
        resolve: { seo: SeoResolver },
        data: { pageCode: 'submit_ride' }
      },
      {
        path: 'cart',
        loadComponent: () =>
          import('./app/templates/cart/cart.component').then(m => m.CartComponent),
        resolve: { seo: SeoResolver },
        data: { pageCode: 'shopping_cart' }
      },
      {
        path: 'sign-up',
        loadComponent: () =>
          import('./app/templates/sign-up/sign-up.component').then(m => m.SignUpComponent),
        resolve: { seo: SeoResolver },
        data: { pageCode: 'sign-in' }
      },
      {
        path: 'forget-password',
        loadComponent: () =>
          import('./app/templates/forget-password/forget-password.component').then(m => m.ForgetPasswordComponent),
        resolve: { seo: SeoResolver },
        data: { pageCode: 'forgot_password' }
      },
      {
        path: 'dealer-inquiries',
        loadComponent: () =>
          import('./app/header/component/dealer-inquiries/dealer-inquiries.component').then(m => m.DealerInquiriesComponent),
        resolve: {seo:SeoResolver}
      },
      {
        path: 'installer-inquiries',
        loadComponent: () =>
          import('./app/header/component/dealer-inquiries/dealer-inquiries.component').then(m => m.DealerInquiriesComponent)
      },
      {
        path: 'dealer-inquiries/dealer-inquiry-thankyou',
        loadComponent: () =>
          import('./app/header/component/dealer-inquiries/dealer-inquiry-thankyou/dealer-inquiry-thankyou.component').then(m => m.DealerInquiryThankyouComponent),
        resolve: {seo:SeoResolver}
      },
      {
        path: 'installer-inquiries/installer-inquiry-thankyou',
        loadComponent: () =>
          import('./app/header/component/dealer-inquiries/dealer-inquiry-thankyou/dealer-inquiry-thankyou.component').then(m => m.DealerInquiryThankyouComponent)
      },
      {
        path: 'speed-analyzer',
        loadComponent: () =>
          import('./app/header/component/speed-analyzer/speed-analyzer.component').then(m => m.SpeedAnalyzerComponent),
        resolve: {seo:SeoResolver}
      },
      {
        path: 'quick-quote',
        loadComponent: () =>
          import('./app/header/component/get-a-quote/get-a-quote.component').then(m => m.GetAQuoteComponent),
        resolve: {seo:SeoResolver}
      },
      // DEALER MAP PATHS
      {
        path: 'dealer-locator',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: {seo:SeoResolver}
      },
      {
        path: 'AL',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'AK',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'AZ',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'AR',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'CA',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'CO',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'CT',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'DE',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'FL',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'GA',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'HI',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'ID',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'IL',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'IN',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'KS',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'KY',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'LA',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'ME',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'MD',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'MA',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'MI',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'MN',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'MS',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'MO',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver ,seo: SeoResolver}
      },
      {
        path: 'MT',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'NE',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'NV',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'NH',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'NJ',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'NM',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'NY',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'NC',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'ND',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'OH',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'OK',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'OR',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'PA',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'RI',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'SC',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'SD',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'TN',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'TX',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'UT',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'VA',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'WA',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'WV',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'WI',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'WY',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { state: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'zip-city-state-search',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { nodealer: dealerLocatorComponentResolver, seo: SeoResolver }
      },
      {
        path: 'international-region/92',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { regionId: dealerLocatorGoogleMapsResolver, seo: SeoResolver }
      },
      {
        path: 'international-region/:id',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { regionId: dealerLocatorGoogleMapsResolver, seo: SeoResolver }
      },
      {
        path: 'location/:dealer',
        loadComponent: () =>
          import('./app/header/component/dealer-locator/dealer-locator.component').then(m => m.DealerLocatorComponent),
        resolve: { contactDealer: contactDealerComponentResolver, seo: SeoResolver }
      },
      {
        path: 'checkout',
        loadComponent: () =>
          import('./app/templates/checkout/checkout.component').then(m => m.CheckoutComponent),
        resolve: {seo:SeoResolver},
        data: { pageCode: 'checkout' }
      },
      {
        path: 'contact-us',
        loadComponent: () =>
          import('./app/templates/contact-us/contact-us.component').then(m => m.ContactUsComponent),
        resolve: {seo:SeoResolver},
        data: { pageCode: 'contact-us' }
      },
      {
        path: 'contact-us-thankyou',
        loadComponent: () =>
          import('./app/templates/contact-us/component/contact-us-thankyou/contact-us-thankyou.component').then(m => m.ContactUsThankyouComponent),
        resolve: {seo:SeoResolver},
      },
      {
        path: 'privacy-policy',
        loadComponent: () =>
          import('./app/templates/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent),
        data: { pageCode: 'privacy-policy' },
        resolve: {seo:SeoResolver},
      },
      {
        path: 'about-us',
        loadComponent: () =>
          import('./app/templates/about-us/about-us.component').then(m => m.AboutUsComponent),
        resolve: {seo:SeoResolver},
        data: { pageCode: 'about-us' }
      },
      {
        path: 'terms-conditions',
        loadComponent: () =>
          import('./app/templates/terms-conditions/terms-conditions.component').then(m => m.TermsConditionsComponent),
        resolve: {seo:SeoResolver},
      },
      {
        path: 'reset-password',
        loadComponent: () =>
          import('./app/templates/forget-password/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
        resolve: {seo:SeoResolver},
      },
      {
        path: 'blog',
        loadComponent: () =>
          import('./app/templates/blog/blog.component').then(m => m.BlogComponent),
        data: { pageCode: 'blog' },
        resolve: { blog: blogComponentResolver,seo:SeoResolver },
      },
      {
        path: 'blog/page/:pageCode',
        loadComponent: () =>
          import('./app/templates/blog/blog.component').then(m => m.BlogComponent),
        data: { pageCode: 'blog' },
        resolve: { blog: blogComponentResolver, seo:SeoResolver },
      },
      {
        path: 'careers',
        loadComponent: () =>
          import('./app/templates/careers/careers.component').then(m => m.CareersComponent),
        resolve: {seo:SeoResolver},
        data: { pageCode: 'careers' }
      },
      {
        path: 'my-orders',
        loadComponent: () =>
          import('./app/templates/my-account/component/my-orders/my-orders.component').then(m => m.MyOrdersComponent),
        resolve: {seo:SeoResolver},
        data: { pageCode: 'my-order' },
        canActivate: [AuthGuard]
      },
      {
        path: 'my-account',
        loadComponent: () =>
          import('./app/templates/my-account/my-account.component').then(m => m.MyAccountComponent),
        resolve: {seo:SeoResolver},
        data: { pageCode: 'my_account' },
        canActivate: [AuthGuard]
      },
      {
        path: 'refer-a-friend',
        loadComponent: () =>
          import('./app/templates/my-account/component/refer-a-friend/refer-a-friend.component').then(m => m.ReferAFriendComponent),
        resolve: {seo:SeoResolver},
        data: { pageCode: 'refer_a_friend' },
        canActivate: [AuthGuard]
      },
      {
        path: 'my-wishlist',
        loadComponent: () =>
          import('./app/templates/my-account/component/my-wishlist/my-wishlist.component').then(m => m.MyWishlistComponent),
        resolve: {seo:SeoResolver},
        data: { pageCode: 'my-wishlist' },
        canActivate: [AuthGuard]
      },
      {
        path: 'my-address',
        loadComponent: () =>
          import('./app/templates/my-account/component/my-address/my-address.component').then(m => m.MyAddressComponent),
        resolve: {seo:SeoResolver},
        canActivate: [AuthGuard]
      },
      {
        path: 'change-password',
        loadComponent: () =>
          import('./app/templates/my-account/component/change-password/change-password.component').then(m => m.ChangePasswordComponent),
        resolve: {seo:SeoResolver},
        canActivate: [AuthGuard]
      },
      {
        path: 'categories',
        loadComponent: () =>
          import('./app/templates/categories/categories.component').then(m => m.CategoriesComponent),
        resolve: {seo:SeoResolver},
      },
      {
        path: 'parts-and-accessories',
        loadComponent: () =>
          import('./app/templates/categories/categories.component').then(m => m.CategoriesComponent),
        resolve: {seo:SeoResolver},
      },
      {
        path: 'shop-4x4-parts',
        loadComponent: () =>
          import('./app/templates/categories/categories.component').then(m => m.CategoriesComponent)
      },
      {
        path: 'brands',
        loadComponent: () =>
          import('./app/templates/brands/brands.component').then(m => m.BrandsComponent),
        resolve: {seo:SeoResolver},
        data: { pageCode: 'brands' }
      },
      {
        path: 'brands/page/:pageCode',
        loadComponent: () =>
          import('./app/templates/brands/brands.component').then(m => m.BrandsComponent),
        resolve: {seo:SeoResolver},
        data: { pageCode: 'brands' }
      },
      {
        path: 'shop-by-hobby',
        loadComponent: () =>
          import('./app/templates/shop-by-hobby/shop-by-hobby.component').then(m => m.ShopByHobbyComponent),
        resolve: {seo:SeoResolver},
      },
      {
        path: 'service/:name',
        loadComponent: () =>
          import('./app/templates/service/service.component').then(m => m.ServiceComponent),
        resolve: {seo:SeoResolver},
        data: { pageCode: 'service' }
      },
      {
        path: 'brand-products/:brandName/:brandId',
        loadComponent: () =>
          import('./app/templates/brands/component/brand-products/brand-products.component').then(m => m.BrandProductsComponent),
        resolve: {seo:SeoResolver},
        data: { pageCode: 'brand_details'}
      },
      {
        path: 'brand-products/:brandName/:brandId/page/:pageCode',
        loadComponent: () =>
          import('./app/templates/brands/component/brand-products/brand-products.component').then(m => m.BrandProductsComponent),
        resolve: {seo:SeoResolver},
        data: { pageCode: 'brand_details'}
      },
      {
        path: 'video-gallery',
        loadComponent: () =>
          import('./app/templates/video-gallery/video-gallery.component').then(m => m.VideoGalleryComponent),
        resolve: {seo:SeoResolver},
        data: { pageCode: 'video_gallery' }
      },
      {
        path: 'video-gallery/page/:pageCode',
        loadComponent: () =>
          import('./app/templates/video-gallery/video-gallery.component').then(m => m.VideoGalleryComponent),
        resolve: {seo:SeoResolver},
        data: { pageCode: 'video_gallery' }
      },
      {
        path: 'order-status',
        loadComponent: () =>
          import('./app/templates/payment-handler/order-status/order-status.component').then(m => m.OrderStatusComponent),
        resolve: {seo:SeoResolver}
      },
      {
        path: 'order-invoice',
        loadComponent: () =>
          import('./app/templates/my-account/component/invoice-tracking/invoice-tracking.component').then(m => m.InvoiceTrackingComponent),
        resolve: {seo:SeoResolver},
        canActivate: [AuthGuard]
      },
      {
        path: 'track-order-details',
        loadComponent: () =>
          import('./app/templates/track-order-details/track-order-details.component').then(m => m.TrackOrderDetailsComponent),
        resolve: {seo:SeoResolver},
        data: { pageCode: 'track-order-details' },
        canActivate: [AuthGuard]
      },
      {
        path: 'our-services',
        loadComponent: () =>
          import('./app/templates/our-services/our-services.component').then(m => m.OurServicesComponent),
        resolve: {seo:SeoResolver},
      },
      {
        path: 'customer-service',
        loadComponent: () =>
          import('./app/templates/customer-support-service/customer-support-service.component').then(m => m.CustomerSupportServiceComponent),
        resolve: {seo:SeoResolver},
        data: { pageCode: 'customer-service' }
      },
      {
        path: 'career-application/:id',
        loadComponent: () =>
          import('./app/templates/careers/component/career-application/career-application.component').then(m => m.CareerApplicationComponent),
        resolve: {seo:SeoResolver}
      },
      {
        path: 'career-application-thankyou',
        loadComponent: () =>
          import('./app/templates/careers/component/career-application-thankyou/career-application-thankyou.component').then(m => m.CareerApplicationThankyouComponent),
        resolve: {seo:SeoResolver}
      },
      {
        path: 'vehicle-search',
        loadComponent: () =>
          import('./app/templates/search-by-vehicle/component/vehicle-search/vehicle-search.component').then(m => m.VehicleSearchComponent),
        resolve: {seo:SeoResolver}
      },
      {
        path: 'vehicle-search/page/:pageCode',
        loadComponent: () =>
          import('./app/templates/search-by-vehicle/component/vehicle-search/vehicle-search.component').then(m => m.VehicleSearchComponent),
        resolve: {seo:SeoResolver}
      },
      {
        path: 'payment-handler',
        loadComponent: () =>
          import('./app/templates/payment-handler/payment-handler.component').then(m => m.PaymentHandlerComponent),
        resolve: {seo:SeoResolver}
      },
      {
        path: 'order-details',
        loadComponent: () =>
          import('./app/templates/my-account/component/my-orders/order-details/order-details.component').then(m => m.OrderDetailsComponent),
        resolve: {seo:SeoResolver},
        canActivate: [AuthGuard]
      },
      {
        path: 'video-gallery-details',
        loadComponent: () =>
          import('./app/templates/video-gallery/video-gallery-details/video-gallery-details.component').then(m => m.VideoGalleryDetailsComponent),
        resolve: {seo:SeoResolver}
      },
      {
        path: 'video-gallery/:videoName/:videoKey',
        loadComponent: () =>
          import('./app/templates/video-gallery/video-gallery-details/video-gallery-details.component').then(m => m.VideoGalleryDetailsComponent),
        resolve: {seo:SeoResolver},
        data: { pageCode: 'video_details' }
      },
      {
        path: 'social-redirect',
        loadComponent: () =>
          import('./app/templates/customer-login/social-redirect/social-redirect.component').then(m => m.SocialRedirectComponent),
        resolve: {seo:SeoResolver},
      },
      {
        path: 'logout',
        loadComponent: () =>
          import('./app/header/header-top/component/logout/logout.component').then(m => m.LogoutComponent),
        resolve: {seo:SeoResolver},
      },
      {
        path: 'blog/:blogName/:blogid',
        loadComponent: () =>
          import('./app/templates/latest-news/component/blog-details/blog-details.component').then(m => m.BlogDetailsComponent),
        resolve: {seo:SeoResolver},
        data: { pageCode: 'blog_details' }
      },
      {
        path: 'news/:category/:blogid',
        loadComponent: () =>
          import('./app/templates/blog/blog.component').then(m => m.BlogComponent),
        resolve: {
          blogid: newsComponentResolver,
          seo:SeoResolver
        }
      },
      {
        path: 'customer-gallery/:galleryName/:galleryKey',
        loadComponent: () =>
          import('./app/templates/customer-gallery/component/customer-gallery-details/customer-gallery-details.component').then(m => m.CustomerGalleryDetailsComponent),
        resolve: {seo:SeoResolver},
        data: { pageCode: 'gallery_details' }
      },
      {
        path: 'help-desk',
        loadComponent: () =>
          import('./app/templates/help-desk/help-desk.component').then(m => m.HelpDeskComponent),
        data: { pageCode: 'help_desk' },
        resolve: {seo:SeoResolver},
      },
      {
        path: 'thank-you',
        loadComponent: () =>
          import('./app/templates/thank-you-page/thank-you-page.component').then(m => m.ThankYouPageComponent),
        resolve: {seo:SeoResolver},
      },
      {
        path: 'kustomize-ur-ride',
        loadComponent: () =>
          import('./app/templates/kustomize-ur-ride/kustomize-ur-ride.component').then(m => m.KustomizeUrRideComponent),
        resolve: {seo:SeoResolver},
      },
      {
        path: 'search',
        loadComponent: () =>
          import('./app/templates/search/search.component').then(m => m.SearchComponent),
        resolve: {seo:SeoResolver},
      },
      {
        path: 'search/page/:pageCode',
        loadComponent: () =>
          import('./app/templates/search/search.component').then(m => m.SearchComponent),
        resolve: {seo:SeoResolver},
      },
      {
        path: 'category/:servicename',
        loadComponent: () =>
          import('./app/templates/product-category-brand-redirect/product-category-brand-redirect.component').then(m => m.ProductCategoryBrandRedirectComponent),
        resolve: {seo:SeoResolver},
      },
      {
        path: 'shop',
        children: [
          {
            path: '**',
            loadComponent: () =>
              import('./app/templates/categories/categories.component').then(m => m.CategoriesComponent),
            resolve: {seo:SeoResolver}
          }
        ]
      },
      {
        path: ':name/:id',
        loadComponent: () =>
          import('./app/templates/placeholder/placeholder.component').then(m => m.PlaceholderComponent),
        resolve: {
          component: placeholderComponentResolver, seo:SeoResolver
        },
        data: { pageCode: '' }
      },
      {
        path: ':name/:id/page/:pageCode',
        loadComponent: () =>
          import('./app/templates/placeholder/placeholder.component').then(m => m.PlaceholderComponent),
        resolve: {
          component: placeholderComponentResolver, seo:SeoResolver
        },
        data: { pageCode: '' }
      },
      {
        path: 'pagenotfound',
        loadComponent: () =>
          import('./app/templates/error-page/error-page.component').then(m => m.ErrorPageComponent),
        resolve: {seo:SeoResolver},
        data: { pageCode: 'pagenotfound' }
      },
      {
        path: ':servicename',
        loadComponent: () =>
          import('./app/templates/product-category-brand-redirect/product-category-brand-redirect.component').then(m => m.ProductCategoryBrandRedirectComponent),
        resolve: {seo:SeoResolver},
        data: { pageCode: 'service' }
      },
      {
        path: '',
        redirectTo: '/',
        pathMatch: 'full'
      },
      {
        path: '**',
        redirectTo: '/pagenotfound'
      },
    ]
  },
];